/**
 * Données de test pour la page Inventaire
 * Séparées pour meilleure maintenabilité
 */

import type { InventoryItem } from "./inventaireTypes";

export const initialItems: InventoryItem[] = [
  {
    id: "0001",
    nom: "Bière artisanale IPA",
    categorie: "Bières",
    image: "https://images.unsplash.com/photo-1732820240720-bef20afb3d67?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjcmFmdCUyMGJlZXIlMjBib3R0bGUlMjBiYXJ8ZW58MXx8fHwxNzcwNjk4MTE1fDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 7.50,
    prixCoutant: 3.25,
    quantite: 48,
    statut: "Actif",
    source: "pos",
    typeItem: "produit_simple",
    formatQuantite: 473,
    formatUnite: "ml",
  },
  {
    id: "0002",
    nom: "Mojito",
    categorie: "Cocktails",
    image: "https://images.unsplash.com/photo-1730390772308-0ae7f139d042?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb2ppdG8lMjBjb2NrdGFpbCUyMGdsYXNzfGVufDF8fHx8MTc3MDY5ODExNXww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 12.00,
    prixCoutant: 4.50,
    quantite: 0,
    statut: "Actif",
    source: "pos",
    typeItem: "recette",
    recetteId: "REC001",
    composition: [
      { itemId: "I001", nom: "Rhum blanc", quantite: 60, unite: "ml" },
      { itemId: "I005", nom: "Menthe fraîche", quantite: 10, unite: "unité" },
      { itemId: "I006", nom: "Lime", quantite: 1, unite: "unité" },
      { itemId: "I010", nom: "Eau gazeuse", quantite: 100, unite: "ml" },
      { itemId: "I007", nom: "Sirop simple", quantite: 15, unite: "ml" },
    ],
  },
  {
    id: "0003",
    nom: "Margarita classique",
    categorie: "Cocktails",
    image: "https://images.unsplash.com/photo-1655546837806-76a6dd54ee2b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtYXJnYXJpdGElMjBjb2NrdGFpbCUyMGdsYXNzfGVufDF8fHx8MTc3MDY2MzY1NXww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 11.50,
    prixCoutant: 4.75,
    quantite: 15,
    statut: "Actif",
    source: "pos",
    typeItem: "recette",
    recetteId: "REC002",
    inCart: true,
    composition: [
      { itemId: "I003", nom: "Tequila", quantite: 50, unite: "ml" },
      { itemId: "I009", nom: "Triple sec", quantite: 25, unite: "ml" },
      { itemId: "I006", nom: "Lime", quantite: 1, unite: "unité" },
      { itemId: "I007", nom: "Sirop simple", quantite: 10, unite: "ml" },
    ],
  },
  {
    id: "0004",
    nom: "Vin rouge (verre)",
    categorie: "Vins",
    image: "https://images.unsplash.com/photo-1712645376049-a8d414d4a364?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxyZWQlMjB3aW5lJTIwZ2xhc3MlMjBwb3VyfGVufDF8fHx8MTc3MDY5ODExNXww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 9.00,
    prixCoutant: 8.75,
    quantite: 24,
    statut: "Actif",
    source: "pos",
    typeItem: "produit_simple",
    formatQuantite: 750,
    formatUnite: "ml",
  },
  {
    id: "0005",
    nom: "Vin blanc (verre)",
    categorie: "Vins",
    image: "https://images.unsplash.com/photo-1597905722448-a1df7c00000a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx3aGl0ZSUyMHdpbmUlMjBnbGFzc3xlbnwxfHx8fDE3NzA2NTkzNzh8MA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 8.50,
    prixCoutant: 3.80,
    quantite: 18,
    statut: "Actif",
    source: "pos",
    typeItem: "produit_simple",
    formatQuantite: 750,
    formatUnite: "ml",
    deliveryInfo: {
      orderId: "CMD-2024-001",
      supplierName: "Vins du Monde",
      estimatedDate: "2024-03-15",
      quantity: 24,
    },
  },
  {
    id: "0006",
    nom: "Pizza pepperoni",
    categorie: "Nourriture",
    image: "https://images.unsplash.com/photo-1631347155591-c162abe23014?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwZXBwZXJvbmklMjBwaXp6YSUyMHNsaWNlfGVufDF8fHx8MTc3MDY3MDg0OXww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 14.99,
    prixCoutant: 6.50,
    quantite: 12,
    statut: "Actif",
    source: "pos",
    typeItem: "produit_simple",
  },
  {
    id: "0007",
    nom: "Chips BBQ",
    categorie: "Collations",
    image: "https://images.unsplash.com/photo-1694101493190-acc6c4418ad7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwb3RhdG8lMjBjaGlwcyUyMGJhZ3xlbnwxfHx8fDE3NzA2Mjk1NTZ8MA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 3.50,
    prixCoutant: 1.25,
    quantite: 64,
    statut: "Actif",
    source: "pos",
    typeItem: "produit_simple",
  },
  {
    id: "0008",
    nom: "Eau embouteillée",
    categorie: "Boissons",
    image: "https://images.unsplash.com/photo-1601507793214-77d2a926582a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx3YXRlciUyMGJvdHRsZSUyMHBsYXN0aWN8ZW58MXx8fHwxNzcwNjk4MTE2fDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 2.50,
    prixCoutant: 0.75,
    quantite: 120,
    statut: "Actif",
    source: "pos",
    typeItem: "produit_simple",
  },
  {
    id: "0009",
    nom: "Coca-Cola",
    categorie: "Boissons",
    image: "https://images.unsplash.com/photo-1621687564000-2495018ee08b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjb2NhJTIwY29sYSUyMHNvZGElMjBjYW58ZW58MXx8fHwxNzcwNjk4MTE3fDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 3.00,
    prixCoutant: 3.25,
    quantite: 85,
    statut: "Actif",
    source: "pos",
    typeItem: "produit_simple",  // Peut aussi être ingrédient pour Cuba Libre, mais vendu tel quel
  },
  {
    id: "0010",
    nom: "Palette chocolat Snickers",
    categorie: "Collations",
    image: "https://images.unsplash.com/photo-1625035446600-9c5c6b1e4b02?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzbmlja2VycyUyMGNob2NvbGF0ZSUyMGJhcnxlbnwxfHx8fDE3NzE1MjUxNDd8MA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 2.75,
    prixCoutant: 1.10,
    quantite: 45,
    statut: "Actif",
    source: "pos",
    typeItem: "produit_simple",
    inCart: true,
  },
  {
    id: "0011",
    nom: "Whisky Sour",
    categorie: "Cocktails",
    image: "https://images.unsplash.com/photo-1641074119761-6d9f1187ee5e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx3aGlza2V5JTIwc291ciUyMGNvY2t0YWlsfGVufDF8fHx8MTc3MDY5NzE1MHww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 13.50,
    prixCoutant: 5.25,
    quantite: 8,
    statut: "Actif",
    source: "pos",
    typeItem: "recette",
    recetteId: "REC004",
  },
  {
    id: "0012",
    nom: "Nachos au fromage",
    categorie: "Nourriture",
    image: "https://images.unsplash.com/photo-1717616870033-324057c397a3?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxuYWNob3MlMjBjaGVlc2UlMjBqYWxhcGVub3xlbnwxfHx8fDE3NzA2Mzc5ODR8MA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 9.99,
    prixCoutant: 4.20,
    quantite: 28,
    statut: "Actif",
    source: "pos",
    typeItem: "produit_simple",
  },
  {
    id: "0013",
    nom: "Café espresso",
    categorie: "Boissons",
    image: "https://images.unsplash.com/photo-1645445644664-8f44112f334c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxlc3ByZXNzbyUyMGNvZmZlZSUyMGN1cHxlbnwxfHx8fDE3NzA2MzU4MzJ8MA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 3.75,
    prixCoutant: 0.85,
    quantite: 92,
    statut: "Actif",
    source: "pos",
    typeItem: "produit_simple",
  },
  {
    id: "0014",
    nom: "Arachides salées",
    categorie: "Collations",
    image: "https://images.unsplash.com/photo-1641718085818-2f0432d84fe4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwZWFudXRzJTIwc25hY2slMjBib3dsfGVufDF8fHx8MTc3MDY5ODExOXww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 4.25,
    prixCoutant: 1.50,
    quantite: 38,
    statut: "Actif",
    source: "pos",
    typeItem: "produit_simple",
  },
  {
    id: "0015",
    nom: "Bretzels",
    categorie: "Collations",
    image: "https://images.unsplash.com/photo-1568254184053-bb6f2232d929?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwcmV0emVsJTIwc25hY2slMjB0d2lzdGVkfGVufDF8fHx8MTc3MDY5ODExOXww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 3.99,
    prixCoutant: 1.35,
    quantite: 52,
    statut: "Actif",
    source: "pos",
    typeItem: "produit_simple",
  },
  // Ingrédients ajoutés manuellement (non vendables)
  {
    id: "I001",
    nom: "Rhum blanc",
    categorie: "Alcools",
    image: "https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxydW0lMjBib3R0bGU8ZW58MXx8fHwxNzcwNjk4MTE5fDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 0,
    prixCoutant: 28.00,
    quantite: 12,
    statut: "Actif",
    source: "manuel",
    typeItem: "ingredient",
    formatQuantite: 750,
    formatUnite: "ml",
  },
  {
    id: "I002",
    nom: "Vodka",
    categorie: "Alcools",
    image: "https://images.unsplash.com/photo-1663782463991-17b45e3bca07?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx2b2RrYSUyMGJvdHRsZSUyMGNsZWFyfGVufDF8fHx8MTc3MTQ4MzQxNXww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 0,
    prixCoutant: 25.00,
    quantite: 8,
    statut: "Actif",
    source: "manuel",
    typeItem: "ingredient",
    formatQuantite: 1000,
    formatUnite: "ml",
    deliveryInfo: {
      orderId: "CMD-2024-123",
      supplierName: "Alcools Prestige",
      estimatedDate: "2026-02-21",
      quantity: 12,
    },
  },
  {
    id: "I003",
    nom: "Tequila",
    categorie: "Alcools",
    image: "https://images.unsplash.com/photo-1718881949298-b658a109bf0b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx0ZXF1aWxhJTIwYm90dGxlJTIwYWdhdmV8ZW58MXx8fHwxNzcxNTI1MTQ4fDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 0,
    prixCoutant: 32.00,
    quantite: 6,
    statut: "Actif",
    source: "manuel",
    typeItem: "ingredient",
    formatQuantite: 750,
    formatUnite: "ml",
  },
  {
    id: "I004",
    nom: "Whisky",
    categorie: "Alcools",
    image: "https://images.unsplash.com/photo-1767217667288-8b50f1dc2103?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx3aGlza2V5JTIwYm90dGxlJTIwYW1iZXJ8ZW58MXx8fHwxNzcxNDgzNDE0fDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 0,
    prixCoutant: 45.00,
    quantite: 5,
    statut: "Actif",
    source: "manuel",
    typeItem: "ingredient",
    formatQuantite: 750,
    formatUnite: "ml",
  },
  {
    id: "I005",
    nom: "Menthe fraîche",
    categorie: "Garnitures",
    image: "https://images.unsplash.com/photo-1628556270448-4d4e4148e1b1?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtaW50JTIwbGVhdmVzJTIwZnJlc2h8ZW58MXx8fHwxNzcwNjk4MTIwfDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 0,
    prixCoutant: 2.50,
    quantite: 20,
    statut: "Actif",
    source: "manuel",
    typeItem: "ingredient",
    formatQuantite: 1,
    formatUnite: "botte",
    deliveryInfo: {
      orderId: "CMD-2024-089",
      supplierName: "Ferme Bio Locale",
      estimatedDate: "2026-02-20",
      quantity: 30,
    },
  },
  {
    id: "I006",
    nom: "Lime",
    categorie: "Garnitures",
    image: "https://images.unsplash.com/photo-1582169296194-e4d644c48063?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxsaW1lJTIwZnJ1aXR8ZW58MXx8fHwxNzcwNjk4MTIwfDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 0,
    prixCoutant: 0.50,
    quantite: 80,
    statut: "Actif",
    source: "manuel",
    typeItem: "ingredient",
    formatQuantite: 1,
    formatUnite: "unité",
  },
  {
    id: "I007",
    nom: "Sirop simple",
    categorie: "Mixers",
    image: "https://images.unsplash.com/photo-1726758004519-7ccecda8b076?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzaW1wbGUlMjBzeXJ1cCUyMGJvdHRlZXxlbnwxfHx8fDE3NzE1MjUxNDl8MA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 0,
    prixCoutant: 3.00,
    quantite: 15,
    statut: "Actif",
    source: "manuel",
    typeItem: "ingredient",
    formatQuantite: 750,
    formatUnite: "ml",
  },
  {
    id: "I008",
    nom: "Jus de citron",
    categorie: "Mixers",
    image: "https://images.unsplash.com/photo-1600271886742-f049cd451bba?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxsZW1vbiUyMGp1aWNlJTIwYm90dGxlJTIwYWdhdmV8ZW58MXx8fHwxNzcxNTI1MTQ4fDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 0,
    prixCoutant: 4.50,
    quantite: 10,
    statut: "Actif",
    source: "manuel",
    typeItem: "ingredient",
    formatQuantite: 500,
    formatUnite: "ml",
  },
  {
    id: "I009",
    nom: "Triple sec",
    categorie: "Alcools",
    image: "https://images.unsplash.com/photo-1711185894231-af93577597aa?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxvcmFuZ2UlMjBsaXF1ZXVyJTIwY29pbnRyZWF1fGVufDF8fHx8MTc3MTUyNTE0OXww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 0,
    prixCoutant: 18.00,
    quantite: 7,
    statut: "Actif",
    source: "manuel",
    typeItem: "ingredient",
    formatQuantite: 750,
    formatUnite: "ml",
  },
  {
    id: "I010",
    nom: "Eau gazeuse",
    categorie: "Mixers",
    image: "https://images.unsplash.com/photo-1629743094483-f1d068ddb29c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzcGFya2xpbmclMjB3YXRlciUyMGJvdHRlZXxlbnwxfHx8fDE3NzE0Mjg0NTN8MA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    prixVente: 0,
    prixCoutant: 1.50,
    quantite: 25,
    statut: "Actif",
    source: "manuel",
    typeItem: "ingredient",
    formatQuantite: 355,
    formatUnite: "ml",
  },
];